const GROUP = 'GROUP';

export function fetchCameraIdentifier(cameraIdentifier: string | undefined, groupPicturesExpected: boolean) {
  if (!!cameraIdentifier) {
    return cameraIdentifier?.substring(0, 7);
  } else {
    if (groupPicturesExpected) {
      return GROUP;
    } else {
      return '';
    }
  }
}
